// Map active flag to badge variant. "success" matches the active-badge variant used across
// campaigns (see getCampaignStatus) so active status reads consistently everywhere.
export function getStatusBadgeType(isActive: boolean): "success" | "neutral" {
  return isActive ? "success" : "neutral";
}

// i18n key for the active/inactive status label. Caller translates via t().
export function getStatusLabelKey(isActive: boolean): string {
  return isActive ? "common.active" : "common.inactive";
}
